import Vue from "vue";
import Router from "vue-router";
import NATIVE from "@/utils/native";
import { setWebviewTitle } from "@/utils/common.js";
import { setPlatformTheme } from "@/utils/theme.js";
import store from "../store";
import I18N from "@/i18n/i18n";
import appStore from "../store/modules/app.js";
import storeStore from "../store/modules/store.js";
import { Locale } from "vant";
// vant语言包
import zhCN from "vant/es/locale/lang/zh-CN";
import enUS from "vant/es/locale/lang/en-US";
import thTH from "vant/es/locale/lang/th-TH";
import msMY from "../i18n/vant-locales/ms-MY";
import viVN from "../i18n/vant-locales/vi-VN";

Vue.use(Router);

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/index"),
    meta: {
      title: () => "."
    }
  },
  {
    path: "/helloWorld",
    name: "HelloWorld",
    component: () => import("@/components/HelloWorld"),
    meta: {
      title: () => "helloWorld"
    }
  },
  {
    path: "/recruit/info-confirm",
    name: "",
    component: () => import("@/views/recruit/2021/info-confirm"),
    meta: {
      title: () => I18N.t("router.Store-Information-Confirmation")
    }
  },
  {
    path: "/recruit/submit",
    name: "",
    component: () => import("@/views/recruit/2021/recruit"),
    meta: {
      title: () => I18N.t("router.Tmall-recruiting")
    }
  },
  {
    path: "/recruit/douyin",
    name: "",
    component: () => import("@/views/recruit/douyin/index"),
    meta: {
      title: () => "抖音招募"
    }
  },
  {
    path: "/learning/exam-level",
    name: "ExamLevel",
    component: () => import("@/views/learning/exam-level.vue"),
    meta: {
      title: () => I18N.t("router.Authentication-level")
    }
  },
  {
    path: "/check-report",
    name: "CheckReport",
    component: () => import("@/views/other/check-report.vue"),
    meta: {
      title: () => I18N.t("router.examining-report")
    }
  },
  {
    path: "/legal-notice",
    name: "LegalNotice",
    component: () => {
      if (appStore.state.country === "china") {
        return import("@/views/protocol/legal-notice.vue");
      } else if (appStore.state.country === "my") {
        return import("@/views/protocol/legal-notice-my.vue");
      }
    },
    meta: {
      title: () => I18N.t("router.legal-notice"),
      unusedToken: true
    }
  },
  {
    path: "/user-agreement",
    name: "UserAgreement",
    component: () => import("@/views/protocol/user-agreement.vue"),
    meta: {
      title: () => I18N.t("router.User-Service-Agreement")
    }
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => {
      if (appStore.state.country === "china") {
        return import("@/views/protocol/privacy-policy.vue");
      } else if (appStore.state.country === "my") {
        return import("@/views/protocol/privacy-policy-my.vue");
      }
    },
    meta: {
      title: () => I18N.t("router.Personal-Information-Protection-policy")
    }
  },
  {
    path: "/make-invoice",
    name: "MakeInvoice",
    component: () => import("@/views/other/make-invoice.vue"),
    meta: {
      title: () => I18N.t("router.issue-an-invoice")
    }
  },
  {
    path: "/profit-analysis",
    name: "ProfixAnalysis",
    component: () => import("@/views/statement/profit-analysis.vue"),
    meta: {
      title: () => I18N.t("router.gross-profit-analysis")
    }
  },
  {
    path: "/revenue-expenditure-analysis",
    name: "RevenueExpenditureAnalysis",
    component: () => import("@/views/statement/revenue-expenditure-analysis.vue"),
    meta: {
      title: () => I18N.t("router.Revenue-and-expenditure-analysis")
    }
  },
  {
    path: "/output-value-analysis",
    name: "OutValueAnalysis",
    component: () => import("@/views/statement/output-value-analysis.vue"),
    meta: {
      title: () => I18N.t("router.Project-output-value-analysis")
    }
  },
  {
    path: "/download",
    name: "Download",
    component: () => {
      if (appStore.state.country === "china") {
        return import("@/views/other/download.vue");
      } else if (appStore.state.country === "my") {
        return import("@/views/other/download-my.vue");
      }
    },
    meta: {
      title: () => I18N.t("router.App-download")
    }
  },
  {
    path: "/test2",
    name: "Test2",
    component: () => import("@/views/debug.vue"),
    meta: {
      title: () => I18N.t("router.test")
    }
  },
  {
    path: "/analysis-of-payment",
    name: "AnalysisOfPayment",
    component: () => import("@/views/statement/analysis-of-payment.vue"),
    meta: {
      title: () => I18N.t("router.Analysis-of-receipts-and-payments")
    }
  },
  {
    path: "/campaign/promotion",
    name: "CampaignPromotion",
    component: () => import("@/views/campaign/promotion.vue"),
    meta: {
      title: () => I18N.t("router.promotion-activity")
    }
  },
  {
    path: "/campaign/turn-draw",
    name: "CampaignTurnDraw",
    component: () => import("@/views/campaign/turn-draw.vue"),
    meta: {
      title: () => I18N.t("router.Slyder-Adventures")
    }
  },
  {
    path: "/campaign/gold-egg",
    name: "CampaignGoldEgg",
    component: () => import("@/views/campaign/gold-egg.vue"),
    meta: {
      title: () => I18N.t("router.smash-golden-eggs")
    }
  },
  {
    path: "/wx-jump",
    name: "WxJump",
    component: () => import("@/views/other/wx-jump.vue"),
    meta: {
      title: () => I18N.t("router.The-jump-in")
    }
  },
  {
    path: "/consult/consult-list",
    name: "consultList",
    component: () => import("@/views/consult/consult-list.vue"),
    meta: {
      title: () => I18N.t("router.Information-list")
    }
  },
  {
    path: "/consult/consult-view",
    name: "consultView",
    component: () => import("@/views/consult/consult-view.vue"),
    meta: {
      title: () => I18N.t("router.Information-for-details")
    }
  },
  {
    path: "/learning/user-study",
    name: "userStudy",
    component: () => import("@/views/learning/user-study.vue"),
    meta: {
      title: () => I18N.t("router.My-learning-interaction")
    }
  },
  {
    path: "/learning/study-record-list",
    name: "studyRecordList",
    component: () => import("@/views/learning/study-record-list.vue"),
    meta: {
      title: () => I18N.t("router.learning-record")
    }
  },
  {
    path: "/learning/study-list",
    name: "studyList",
    component: () => import("@/views/learning/study-list.vue"),
    meta: {
      title: () => I18N.t("router.on-line-study")
    }
  },
  {
    path: "/learning/study-view",
    name: "studyView",
    component: () => import("@/views/learning/study-view.vue"),
    meta: {
      title: () => I18N.t("router.Learn-the-text")
    }
  },
  {
    path: "/learning/study-view-share",
    name: "studyViewShare",
    component: () => import("@/views/learning/study-view-share.vue"),
    meta: {
      title: () => I18N.t("router.Learn-the-text")
    }
  },
  {
    path: "/learning/exam-signup-success",
    name: "examSignupSuccess",
    component: () => import("@/views/learning/exam-signup-success.vue"),
    meta: {
      title: () => I18N.t("router.The-registration-results")
    }
  },
  {
    path: "/learning/exam-list",
    name: "examList",
    component: () => import("@/views/learning/exam-list.vue"),
    meta: {
      title: () => I18N.t("router.My-test")
    }
  },
  {
    path: "/learning/exam-ing/:answerSheetCode",
    name: "examIng",
    component: () => import("@/views/learning/exam-view.vue"),
    meta: {
      title: () => I18N.t("router.during-the-examination")
    }
  },
  {
    path: "/learning/exam-view/:answerSheetCode",
    name: "examView",
    component: () => import("@/views/learning/exam-view.vue"),
    meta: {
      title: () => I18N.t("router.Details-of-the-test")
    }
  },
  {
    path: "/learning/exam-result/:answerSheetCode",
    name: "",
    component: () => import("@/views/learning/exam-submit-success.vue"),
    meta: {
      title: () => I18N.t("router.examination-result")
    }
  },
  {
    path: "/learning/interaction-release",
    name: "interactionRelease",
    component: () => import("@/views/learning/interaction-release.vue"),
    meta: {
      title: () => I18N.t("router.published-topics")
    }
  },
  {
    path: "/learning/interaction-view",
    name: "interactionView",
    component: () => import("@/views/learning/interaction-view.vue"),
    meta: {
      title: () => I18N.t("router.Post-the-body")
    }
  },
  {
    path: "/learning/interaction-mine",
    name: "interactionMine",
    component: () => import("@/views/learning/interaction-mine.vue"),
    meta: {
      title: () => I18N.t("router.My-interactive")
    }
  },
  {
    path: "/statement/turnover",
    name: "statementTurnover",
    component: () => import("@/views/statement/turnover.vue"),
    meta: {
      title: () => I18N.t("router.Turnover-analysis")
    }
  },
  {
    path: "/statement/customer",
    name: "statementCustomer",
    component: () => import("@/views/statement/customer.vue"),
    meta: {
      title: () => I18N.t("router.The-guest-mood-analysis")
    }
  },
  {
    path: "/statement/market",
    name: "statementMarket",
    component: () => import("@/views/statement/tire-sales.vue"),
    meta: {
      title: () => I18N.t("router.Tire-sales-analysis")
    }
  },
  {
    path: "/statement/workshop",
    name: "statementWorkshop",
    component: () => import("@/views/statement/workshop.vue"),
    meta: {
      title: () => I18N.t("router.Kanban-workshop")
    }
  },
  {
    path: "/malaysia/select-position",
    name: "statementWorkshop",
    component: () => import("@/views/malaysia/select-position.vue"),
    meta: {
      title: () => I18N.t("v211030.select-location")
    }
  },
  {
    path: "/op/login",
    name: "opLogin",
    component: () => import("@/views/op/login.vue"),
    meta: {
      title: () => "运营中心登录"
    }
  },
  {
    path: "/buy/buy-info-confirm",
    name: "BuyInfoConfirm",
    component: () => import("@/views/buy/buy-info-confirm.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-version-selection",
    name: "BuyVersionSelection",
    component: () => import("@/views/buy/buy-version-selection.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-pay-select",
    name: "BuyPaySelect",
    component: () => import("@/views/buy/buy-pay-select.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-offline-transfer",
    name: "BuyOfflineTransfer",
    component: () => import("@/views/buy/buy-offline-transfer.vue"),
    meta: {
      title: () => "线下转账"
    }
  },
  {
    path: "/buy/success",
    name: "MemberBuySuccess",
    component: () => import("@/views/buy/buy-success.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-online-contractor",
    name: "BuyOnlineContractor",
    component: () => import("@/views/buy/buy-online-contractor.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-online-contractor",
    name: "BuyOnlineContractor",
    component: () => import("@/views/buy/buy-online-contractor.vue"),
    meta: {
      title: () => "版本购买"
    }
  },
  {
    path: "/buy/buy-history",
    name: "BuyHistory",
    component: () => import("@/views/buy/buy-history.vue"),
    meta: {
      title: () => "购买记录"
    }
  },
  {
    path: "/op/store-apply",
    name: "opStoreApply",
    component: () => import("@/views/op/store-apply.vue"),
    meta: {
      title: () => "创建新门店"
    }
  },
  {
    path: "/op/store-apply/submitted",
    name: "opStoreApply",
    component: () => import("@/views/op/apply-submitted.vue"),
    meta: {
      title: () => "资料已提交"
    }
  },
  {
    path: "/user/check-phone",
    name: "CheckPhone",
    component: () => import("@/views/user/check-phone.vue"),
    meta: {
      title: () => "校验手机号码"
    }
  },
  {
    path: "/user/select-store",
    name: "SelectStore",
    component: () => import("@/views/user/select-store.vue"),
    meta: {
      title: () => "选择门店"
    }
  },
  {
    path: "/campaign/fission/middle-page/:fnCode",
    name: "FissionMiddlePage",
    component: () => import("@/views/campaign/fission/middle-page.vue"),
    meta: {
      title: () => "活动加载中..."
    }
  },
  {
    path: "/campaign/fission/detail/:campaignCode/:storeCode/:customerCode",
    name: "FissionDetail",
    component: () => import("@/views/campaign/fission/detail.vue"),
    meta: {
      title: () => "裂变活动详情"
    }
  },
  {
    path: "/campaign/fission/confirm-order",
    name: "FissionConfirmOrder",
    component: () => import("@/views/campaign/fission/confirm-order.vue"),
    meta: {
      title: () => "确认购买"
    }
  },
  {
    path: "/year-report",
    name: "opStoreApply",
    component: () => import("@/views/other/year-report.vue"),
    meta: {
      title: () => "门店通产品年度报告"
    }
  },
  {
    path: "/campaign/fission/buy-success",
    name: "FissionBuySuccess",
    component: () => import("@/views/campaign/fission/buy-successful.vue"),
    meta: {
      title: () => "购买成功"
    }
  },
  {
    path: "/order/fission",
    name: "FissionOrder",
    component: () => import("@/views/order/fission-order.vue"),
    meta: {
      title: () => "裂变订单"
    }
  },
  {
    path: "/card/detail",
    name: "CardDetail",
    component: () => import("@/views/card/card-detail.vue"),
    meta: {
      title: () => "套餐卡详情"
    }
  },
  {
    path: "/print/service-delegation",
    name: "ServiceDelegate",
    component: () => import("@/views/print/service-delegation.vue"),
    meta: {
      title: () => "服务委托单打印"
    }
  },
  {
    path: "/print/check-delegation",
    name: "ServiceDelegate",
    component: () => import("@/views/print/check-delegation.vue"),
    meta: {
      title: () => "检测委托单打印"
    }
  },
  {
    path: "/instruction/view/:id",
    name: "InstrctionDetail",
    component: () => import("@/views/learning/instruction-view.vue"),
    meta: {
      title: () => "教程详情"
    }
  },
  {
    path: "/debug",
    name: "Debug",
    component: () => import("../views/debug.vue"),
    meta: {
      title: () => "debug"
    }
  },
  {
    path: "/cross-app/message-center",
    name: "CrossAppMessageCenter",
    component: () => import("../views/cross-app/message-center.vue"),
    meta: {
      title: () => "消息"
    }
  },
  {
    path: "/cross-app/customer-center",
    name: "CrossAppCustomerCenter",
    component: () => import("../views/cross-app/customer-center.vue"),
    meta: {
      title: () => "客服中心"
    }
  },
  {
    path: "/cross-app/question-detail/:id",
    name: "CrossAppQuestionDetail",
    component: () => import("../views/cross-app/question-detail.vue"),
    meta: {
      title: () => "问题解答"
    }
  },
  {
    path: "/warranty/card",
    name: "WarrantyCard",
    component: () => import("../views/warranty/card.vue"),
    meta: {
      title: () => I18N.t("router.warranty-card"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/claim-record",
    name: "WarrantyCard",
    component: () => import("../views/warranty/claim-record.vue"),
    meta: {
      title: () => I18N.t("v376.claimRecord"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/claim-history/:warrantyCardNo",
    name: "WarrantyClaimHistory",
    component: () => import("../views/warranty/claim-history.vue"),
    meta: {
      title: () => I18N.t("v376.claimDetail"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/claim-detail/:warrantyCardNo",
    name: "WarrantyClaimDetail",
    component: () => import("../views/warranty/claim-detail.vue"),
    meta: {
      title: () => I18N.t("v376.claimDetail"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/claim-search",
    name: "WarrantyCard",
    component: () => import("../views/warranty/claim-search.vue"),
    meta: {
      title: () => I18N.t("v376.search"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/record",
    name: "WarrantyRecord",
    component: () => import("../views/warranty/record.vue"),
    meta: {
      title: () => I18N.t("router.Warranty-card-record"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/size/:id",
    name: "WarrantySize",
    component: () => import("../views/warranty/size.vue"),
    meta: {
      title: () => I18N.t("router.tire-size"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/pattern/:id",
    name: "WarrantyPattern",
    component: () => import("../views/warranty/pattern.vue"),
    meta: {
      title: () => I18N.t("router.tire-tread-pattern")
    }
  },
  {
    path: "/warranty/reg",
    name: "WarrantyReg",
    component: () => import("../views/warranty/reg.vue"),
    meta: {
      title: () => I18N.t("router.warranty-reg"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/claim",
    name: "WarrantyClaim",
    component: () => import("../views/warranty/claim.vue"),
    meta: {
      title: () => I18N.t("router.warranty-claim")
    }
  },
  {
    path: "/warranty/other-claim",
    name: "WarrantyOtherClaim",
    component: () => import("../views/warranty/other-claim/index.vue"),
    meta: {
      title: () => I18N.t("v380.other-claim"),
      keepAlive: true
    }
  },
  {
    path: "/warranty/preClaim/:warrantyCardNo",
    name: "WarrantyPreClaim",
    component: () => import("../views/warranty/preClaim.vue"),
    meta: {
      title: () => I18N.t("router.warranty-card")
    }
  },
  {
    path: "/warranty/detail/:warrantyCardNo",
    name: "WarrantyDetail",
    component: () => import("../views/warranty/detail.vue"),
    meta: {
      title: () => I18N.t("router.warranty-card")
    }
  },
  {
    path: "/warranty/search",
    name: "WarrantySearch",
    component: () => import("../views/warranty/search.vue"),
    meta: {
      title: () => I18N.t("router.search")
    }
  },
  {
    path: "/warranty-browser/detail/:warrantyCardNo",
    name: "WarrantyBrowserDetail",
    component: () => import("../views/warranty-browser/detail.vue"),
    meta: {
      title: () => I18N.t("router.my-warranty-card"),
      unusedToken: true
    }
  },
  {
    path: "/warranty-browser/assurance",
    name: "WarrantyBrowserAssurance",
    component: () => import("../views/warranty-browser/assurance.vue"),
    meta: {
      title: () => I18N.t("router.giti-shield") + "+",
      unusedToken: true
    }
  },
  {
    path: "/warranty-browser/assurance-my",
    name: "WarrantyBrowserAssuranceMy",
    component: () => import("../views/warranty-browser/assurance-my.vue"),
    meta: {
      title: () => I18N.t("router.giti-shield") + "+ (" + I18N.t("v360.malaysia") + ")",
      unusedToken: true
    }
  },
  {
    path: "/warranty-browser/assurance-my-detail",
    name: "WarrantyBrowserAssuranceMyDetail",
    component: () => import("../views/warranty-browser/assurance-my-detail.vue"),
    meta: {
      title: () => I18N.t("router.giti-shield") + "+",
      unusedToken: true
    }
  },
  {
    path: "/warranty-browser/assurance-th",
    name: "WarrantyBrowserAssuranceTh",
    component: () => import("../views/warranty-browser/assurance-th.vue"),
    meta: {
      title: () => I18N.t("router.giti-shield") + "+ (" + I18N.t("v360.thailand") + ")",
      unusedToken: true
    }
  },
  {
    path: "/warranty-browser/assurance-vn",
    name: "WarrantyBrowserAssuranceVn",
    component: () => import("../views/warranty-browser/assurance-vn.vue"),
    meta: {
      title: () => I18N.t("router.giti-shield") + "+ (" + I18N.t("v360.vietnam") + ")",
      unusedToken: true
    }
  },
  {
    path: "/warranty/claim-type-select",
    name: "WarrantyClaimTypeSelect",
    component: () => import("../views/warranty/claim-type-select.vue"),
    meta: {
      title: () => "Select claim type"
    }
  },
  {
    path: "/warranty/dot-examples",
    name: "WarrantyBrowserAssuranceVn",
    component: () => import("../views/warranty/dot-examples.vue"),
    meta: {
      title: () => "Examples"
    }
  },
  { path: "*", redirect: "/", meta: {} }
];
store.commit(
  "app/setCachesRoutes",
  routes.filter(o => o.meta && o.meta.keepAlive && o.name).map(o => o.name)
);
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  store.commit("app/setTransitionName", "slide-left", { root: true });
  return routerPush.call(this, location).catch(err => err);
};
const routerBack = Router.prototype.back;
Router.prototype.back = function back(location) {
  store.commit("app/setTransitionName", "slide-left", { root: true });
  return routerBack.call(this, location);
};
const routerGo = Router.prototype.go;
Router.prototype.go = function go(location) {
  if (location < 0) {
    store.commit("app/setTransitionName", "slide-right", { root: true });
  }
  return routerGo.call(this, location);
};
let router = new Router({
  mode: "history",
  routes
});
const vantLocales = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "ms-MY": msMY,
  "th-TH": thTH,
  "vi-VN": viVN
};

router.beforeEach(async (to, from, next) => {
  if (!appStore.state.lang) {
    let appLanguage = "zh-CN";
    if (process.env.NODE_ENV === "development") {
      appLanguage = localStorage.getItem("dev_language") || "zh-CN";
    } else {
      appLanguage = await NATIVE.getAppLanguage();
    }
    // 设置vuei18n 语言
    I18N.locale = appLanguage;
    // 设置vant 语言包
    Locale.use("locale", vantLocales[appLanguage]);
    store.commit("app/setLang", appLanguage, { root: true });
  }
  if (!appStore.state.currencyUnit) {
    const appCurrencyInfoStr = await NATIVE.getAppCurrencyInfo();
    const infoArr = appCurrencyInfoStr ? appCurrencyInfoStr.split(",") : ["￥", "元"];
    store.commit("app/setCurrencySymbol", infoArr[0], { root: true });
    store.commit("app/setCurrencyUnit", infoArr[1], { root: true });
  }
  if (!appStore.state.platform) {
    const brand = await NATIVE.getBrand();
    // 设置主题色
    const brandMap = {
      GT: "GT",
      GT_RADIAL: "GR",
      MIXED: "GT" // 混合用GT的样式
    };
    store.commit("app/setPlatform", brandMap[brand], { root: true });
    store.commit("app/setRealPlatform", brand, { root: true });
    setPlatformTheme(brandMap[brand]);
  }
  const TITLE = to.meta.title() || to.query.title;
  setWebviewTitle(TITLE);
  // 获取token
  NATIVE.getUserAuthToken().then(
    data => {
      data && (window.localStorage.authtoken = data);
      console.log("获取的token为", data);
      if (!storeStore.state.countryCode && window.localStorage.authtoken && !to.meta.unusedToken) {
        store.dispatch("store/getCurrentStoreInfo", { root: true });
      }
      next();
    },
    data => {
      console.log("获取token错误", data);
    }
  );
});
router.afterEach(async (to, from, next) => {
  store.commit("base/checkPageHasInstruction", { path: to.fullPath }, { root: true });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js